import { isPlainObject } from '../util/util';

const FILTERED = '[Filtered]';

const TOKEN_PREFIX = 'eyJ';
const JOSE = /\beyJ[\w-]+(?:(?:\.|%2[Ee])[\w-]*){1,4}/g;

const looksLikePhoneNumber = (value: string): boolean => {
  const trimmed = value.trim();
  if (!/^\+?[\d\s()-]+$/.test(trimmed)) return false;
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return false;

  const digits = trimmed.replace(/\D/g, '').replace(/^00/, '');
  return digits.length >= 8 && digits.length <= 15;
};

const holdsSensitiveData = (rawValue: string): boolean => {
  const decoded = new URLSearchParams(`value=${rawValue}`).get('value') ?? '';
  return decoded.startsWith(TOKEN_PREFIX) || looksLikePhoneNumber(decoded);
};

const redactQueryValue = (rawValue: string): string => {
  const trailingPunctuation = rawValue.match(/[.,;:!?)\]}]+$/)?.[0] ?? '';
  const value = rawValue.slice(0, rawValue.length - trailingPunctuation.length);
  return holdsSensitiveData(value) ? `${FILTERED}${trailingPunctuation}` : rawValue;
};

const redactUrlParams = (text: string): string =>
  text.replace(
    /([?&][^\s?&#="'`<>\\]+=)([^\s&#"'`<>\\]*)/g,
    (_, prefix: string, rawValue: string) => `${prefix}${redactQueryValue(rawValue)}`
  );

export const redactSensitiveData = (value: string): string =>
  redactUrlParams(value).replace(JOSE, FILTERED);

export const redactSensitiveDataDeep = <T>(value: T): T => {
  if (typeof value === 'string') {
    return redactSensitiveData(value) as T;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => (value[index] = redactSensitiveDataDeep(item)));
  } else if (isPlainObject(value)) {
    const record: Record<string, unknown> = value;
    Object.keys(record).forEach((key) => (record[key] = redactSensitiveDataDeep(record[key])));
  }

  return value;
};
